export default __webpack_public_path__ + "static/media/11-43.d1d35489.png";